export default "__VITE_ASSET__Cfh8nkHD__"